export default "__VITE_ASSET__aIf5cYQI__"